import styled from '@emotion/styled';
import Tooltip from '@components/Tooltips/Tooltip';
import { useI18n } from '@i18n/useI18n';
import { useStore } from "@store/appStore";
import moment from 'moment';
import { useState } from 'react';
import db from '@utils/db';
import User_Icon from '@assets/svg/new-user.svg';
import toTitleCase from '@utils/textTools';

const Container = styled.div<{ swipeView?: boolean, fullDayView?: boolean, show?: boolean }>`
    display: ${props => props.show ? "flex" : "none"};
    pointer-events: all;
`;

const RegistrationMethod = styled.div<{ swipeView?: boolean, fullDayView?: boolean, iconColor: any }>`
  background:#fff;
  border:${props => props.swipeView ? "3px" : "2px"} solid #AAAAAA;
  border-radius: 3px;
  height:${props => props.swipeView ? "26px" : "18px"};
  aspect-ratio: 1 / 1;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;

  svg{
    height: 80%;
    path{
      fill:${props => props.iconColor === 1 ? "#2A848E" : props.iconColor === 2 ? "#FA505E" : "#FED425"};
    }
  }
`;

const Row = styled.div`
  display:flex;
  

  p{
    width:100px;
    font-weight: 600;
    
  }
`;

interface IProps {
  show?: boolean,
  registrationMethod?: number,
  fullDayView?: boolean;
  swipeView?: boolean;
  studentId: string;
  reservationId: string;
  studentUsername: string;
}

export const RegMethod = (props: IProps) => {  
  const i18n = useI18n();
  const { initialRegistrationTypes, systemSettings } = useStore()
  const [tooltipText, setTooltipText] = useState(null)

  const getColor = () => {
    let initial = initialRegistrationTypes.find(r => r.initial_Registration_Method === props.registrationMethod)
    let colorId = 0
    if (initial) colorId = initial.registration_Type;
    else colorId = props.registrationMethod
    return colorId
  }

  let color = getColor()  

  const getType = (name, username, initialType) => {
    let data = { initialType: initialType, text: "", nulstil: false, name: name }
    if ((name === "SICK_SELF_REGISTRATION" || name === "SICK_TEACHER_REGISTRATION" || name === "SICK_ADMIN_REGISTRATION" || name === "SICK_PARENT_REGISTRATION")) {
      data.text = i18n.t("registrationcount-SICK");
      if (initialType === null || username == props.studentUsername) data.initialType = "SICK";
    } else if ((name === "CHECKIN_BEFORE_LESSON" || name === "CHECKIN_AFTER_LESSON" || name === "CHECKIN_DURING_LESSON_FIXEDLATE_AFTERLATE" || name === "CHECKIN_DURING_LESSON_NOFIXEDLATE")) {
      data.text = i18n.t("qr-check-in");
      if (initialType === null || username == props.studentUsername) data.initialType = "CHECKIN";
      else data.nulstil = true
    } else if ((name === "CHECKOUT_BEFORE_LESSON" || name === "CHECKOUT_AFTER_LESSON" || name === "CHECKOUT_DURING_LESSON_FIXEDLATE" || name === "CHECKOUT_DURING_LESSON_NOFIXEDLATE" || name === "CHECKOUT_DURING_LESSON_PARTIAL")) {
      data.text = i18n.t("qr-check-out");
      if (initialType === null) data.initialType = "CHECKOUT";
    } else if (name === "AUTO_DEFAULT_ABSENCE") {
      data.text = "Auto";
      if (initialType === null) data.initialType = "AUTO";
    } else if (name === "AUTO_CHECK_OUT") {
      data.text = i18n.t("tooltip-registration-method-auto-checkout");
      if (initialType === null) data.initialType = "AUTO CHECKOUT";
    } else if (name === "TEAMS_NO_SHOW" || name === "TEAMS_PARTIALLY_PRESENT" || name === "TEAMS_FULL_ATTENDANCE") {
      data.text = i18n.t("tooltip-registration-method-auto-teams");
      if (initialType === null) data.initialType = "AUTO TEAMS";
    } 
    else if(name === "APPROVED_HOLIDAY_OFF")
    {
      data.text = i18n.t("approved-holiday");
    }
    else {
      data.text = `(${username.toUpperCase()})`;
    }

    if (data.nulstil) data.text = `(${username.toUpperCase()})`;
    return data
  }

  const getTooltipText = async (student_id, reservation_id, student_username) => {
    console.log(student_username)
    let timezone = systemSettings.find((s) => s.APP_Setting_ID === 7);
    let texts = await db.Regi_GetRegistrationLog(student_id, reservation_id, timezone.value)
    console.log(texts)
    let t = []
    let initial = null
    for (let i = 0; i < texts.length; i++) {
      const text = texts[i];

      let data = getType(text.name, text.username, initial)
      if (data.initialType !== null) initial = data.initialType
      let tmp = data.text
      if (text.type === -1 || data.nulstil) {
        tmp += "  > " + toTitleCase(i18n.t("reset"));
      } else if (text.type === 1) {
        tmp += "  > " + toTitleCase(i18n.t('registration-type-present'));
      } else if (text.type === 2) {
        tmp += "  > " + toTitleCase(i18n.t('absent'));
      } else if (text.type === 3) {
        tmp += "  > " + toTitleCase(i18n.t('registration-type-late'));
      }

      t.push(<Row key={"regmethod_" + i}><p>{moment(text.local_timestamp).format('DD/MM HH:mm:ss')}<div /></p><span>{tmp}</span></Row>)
    }
    setTooltipText(t)
  }

  return (
    <Container onMouseEnter={() => getTooltipText(props.studentId, props.reservationId, props.studentUsername)} swipeView={props.swipeView} fullDayView={props.fullDayView} show={props.show}>
      <Tooltip offsetY={-6} content={tooltipText}>
        <RegistrationMethod iconColor={color} swipeView={props.swipeView} fullDayView={props.fullDayView}>
          <User_Icon />
        </RegistrationMethod>
      </Tooltip>
    </Container>
  );
};

export default RegMethod;
